// eslint-disable-next-line import/prefer-default-export
export const LEGAL = 'info/legal-advice';
